// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url:'https://admin.aeemployment.com:8443/ae-admin-api/v1',
  production: true
  // url:'http://ae-admin-test.connectie-t.com:2232/ae-admin-api/v1',
  // url:'http://192.168.1.247:8080/ae-admin-api/v1',

  // url:'http://18.140.22.74:2227/ae-admin-api/v1',
  // url: 'http://18.140.22.74:3333/cartier-api/v1',
  
  // production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
